(function(){
  function $(s,r){return (r||document).querySelector(s)}
  function $$(s,r){return Array.prototype.slice.call((r||document).querySelectorAll(s))}
  $$('[data-gm-cd]').forEach(function(cd){
    var end=Date.parse(cd.getAttribute('data-end')||'');
    var bar=cd.closest('[data-gm-bar]');
    if(isNaN(end)){cd.hidden=true;return}
    function pad(n){return ('0'+n).slice(-2)}
    function tick(){
      var d=end-Date.now();
      if(d<=0){ if(bar) bar.hidden=true; return false }
      var s=Math.floor(d/1000);
      cd.querySelector('[data-d]').textContent=Math.floor(s/86400)+'d';
      cd.querySelector('[data-h]').textContent=pad(Math.floor(s%86400/3600))+'h';
      cd.querySelector('[data-m]').textContent=pad(Math.floor(s%3600/60))+'m';
      cd.querySelector('[data-s]').textContent=pad(s%60)+'s';
      cd.hidden=false; return true;
    }
    if(tick()) setInterval(tick,1000);
  });
  var root=$('[data-gm-buy]'); if(!root) return;
  var track=$('[data-track]',root), slides=$$('.gm-slide',root);
  var dots=$$('[data-dot]',root), thumbs=$$('[data-thumb]',root);
  function current(){return Math.round(track.scrollLeft/track.clientWidth)}
  function go(i,smooth){
    i=Math.max(0,Math.min(slides.length-1,i));
    track.scrollTo({left:i*track.clientWidth,behavior:smooth===false?'auto':'smooth'});
  }
  function mark(){
    var i=current();
    dots.forEach(function(d,k){d.setAttribute('aria-current',k===i)});
    thumbs.forEach(function(t,k){t.setAttribute('aria-current',k===i)});
  }
  var raf; track.addEventListener('scroll',function(){cancelAnimationFrame(raf);raf=requestAnimationFrame(mark)},{passive:true});
  dots.forEach(function(d,k){d.addEventListener('click',function(){go(k)})});
  thumbs.forEach(function(t,k){t.addEventListener('click',function(){go(k)})});
  var prev=$('[data-prev]',root), next=$('[data-next]',root);
  if(prev) prev.addEventListener('click',function(){go(current()-1)});
  if(next) next.addEventListener('click',function(){go(current()+1)});
  function slideFor(title){
    for(var k=0;k<slides.length;k++){ if(slides[k].getAttribute('data-legend')===title && slides[k].getAttribute('data-kind')==='studio') return k }
    return -1;
  }
  var idInput=$('[data-gm-id]',root), vname=$('[data-gm-vname]',root);
  var sticky=$('[data-gm-sticky]'), sImg=$('[data-gm-simg]'), sName=$('[data-gm-sname]');
  var legends=$$('[data-gm-variant]',root);
  function pick(btn,scroll){
    legends.forEach(function(b){b.setAttribute('aria-pressed','false')});
    btn.setAttribute('aria-pressed','true');
    idInput.value=btn.getAttribute('data-gm-variant');
    idInput.dispatchEvent(new Event('change',{bubbles:true}));
    var title=btn.getAttribute('data-title');
    if(vname) vname.textContent=title;
    if(sName) sName.textContent=title;
    if(sImg) sImg.src=btn.getAttribute('data-thumb-src');
    var k=slideFor(title); if(k>-1) go(k);
    if(scroll){ root.scrollIntoView({behavior:'smooth',block:'start'}) }
    try{ history.replaceState(null,'','?variant='+idInput.value+location.hash) }catch(e){}
  }
  legends.forEach(function(b){b.addEventListener('click',function(){pick(b,false)})});
  $$('[data-gm-choose]').forEach(function(b){
    b.addEventListener('click',function(){
      var t=legends.filter(function(x){return x.getAttribute('data-gm-variant')===b.getAttribute('data-gm-choose')})[0];
      if(t) pick(t,true);
    });
  });
  var start=slideFor(vname?vname.textContent.trim():''); if(start>0) go(start,false);
  var qty=$('[data-gm-qty]',root), total=$('[data-gm-total]',root), sTotal=$('[data-gm-stotal]');
  $$('input[name=gm_pack]',root).forEach(function(r){
    r.addEventListener('change',function(){
      if(!r.checked) return;
      qty.value=r.value;
      var t=r.getAttribute('data-total');
      if(total) total.textContent=t; if(sTotal) sTotal.textContent=t;
    });
  });
  var form=$('[data-gm-form]',root), cta=$('[data-gm-cta]',root), sBtn=$('[data-gm-sbtn]');
  if(sBtn&&form) sBtn.addEventListener('click',function(){ if(form.requestSubmit) form.requestSubmit(cta); else form.submit(); });
  if(sticky&&cta){
    var st=function(){ sticky.classList.toggle('is-on', cta.getBoundingClientRect().bottom<0) };
    window.addEventListener('scroll',st,{passive:true}); st();
  }
})();